import { useQueryClient } from '@tanstack/react-query';

export const useInvalidateBulkOperation = (bulkOperationId: string) => {
  const queryClient = useQueryClient();

  const invalidateBulkOperation = () => {
    queryClient.invalidateQueries({
      queryKey: ['bulk-operation', bulkOperationId],
    });
    queryClient.invalidateQueries({ queryKey: ['bulk-operations'] });
  };

  const invalidateReceipts = () => {
    queryClient.invalidateQueries({
      queryKey: ['uploaded-receipts'],
    });
  };

  const invalidateAll = () => {
    invalidateBulkOperation();
    invalidateReceipts();
  };

  return { invalidateBulkOperation, invalidateReceipts, invalidateAll };
};
